import React, { PureComponent } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Typography, Grid, Box } from "@mui/material";

function addHa(value: number) {
return value + " ha";
}

export default function SchadflaechenChart(props: any) {
    // d_wald_20
    const data = [
        {
            name: '2016 - 2020',
            Schaden: props.dashboardData.d_wald_20,
        },
        {
            name: '2020 - 2021',
            Schaden: props.dashboardData.d_wald_21,
        },
        {
            name: '2021 - 2022',
            Schaden: props.dashboardData.d_wald_22,
        },
        {
            name: '2022 - 2023',
            Schaden: props.dashboardData.d_wald_23,
        },
        {
            name: '2023 - 2024',
            Schaden: props.dashboardData.d_wald_24,
        },
        {
            name: '2024 - 2025',
            Schaden: props.dashboardData.d_wald_25,
        },
    ];

    return (
        <>
            <Grid container justifyContent="center">
                <Box fontWeight='fontWeightMedium' display='inline'>
                    {props.title}
                </Box>
            </Grid>
            <ResponsiveContainer
                width="99%"
                aspect={2.2}
            // maxHeight={160} 
            >
                <BarChart
                    // width={500}
                    // height={300}
                    data={data}
                >
                    <CartesianGrid strokeDasharray="3 3" />   
                    <XAxis dataKey="name" />
                    <YAxis tickFormatter={addHa}/>
                    <Tooltip />
                    {/* <Legend /> */}
                    <Bar dataKey="Schaden" fill="#D14343" />
                </BarChart>
            </ResponsiveContainer>

        </>

    );

}
